import platformBackendClient from '@backend-clients/platform-backend';

export default {
  get: (id) => platformBackendClient.get(`/api/models/${id}`),
};
